module.exports = __webpack_public_path__ + "img/ff100d2.png";